import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pieter-smits")({
  head: () => buildRouteHead("/pieter-smits", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/team", replace: true });
  },
});
